import React, { useEffect, useState } from 'react'
import CustomTypography from '../CustomComponents/CustomTypography/CustomTypography';
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import { useStyles } from "../../assets/jss/TableGenerate";
import { useTranslation } from "react-i18next";
import CustomCheckbox from "../CustomComponents/CustomCheckbox/CustomCheckbox";
import CustomFormControlLabel from "../CustomComponents/CustomFormControlLabel/CustomFormControlLabel"
import CustomTextField from "../CustomComponents/CustomTextField/CustomTextField";
import CustomInputAdornment from "../CustomComponents/CustomInputAdornment/CustomInputAdornment"
import CustomIconButton from "../CustomComponents/CustomIconButton/CustomIconButton";
import SearchIcon from '@material-ui/icons/Search';
import IconButton from "@material-ui/core/IconButton"
import HorizontalSplitIcon from '@material-ui/icons/HorizontalSplit';
import CustomMenu from '../CustomComponents/CustomMenu/CustomMenu';
import CustomMenuItem from '../CustomComponents/CustomMenuItem/CustomMenuItem';
import CustomButton from "../CustomComponents/CustomButton/CustomButton";
import CustomSelect from '../CustomComponents/CustomSelect/CustomSelect';
import CustomFormControl from '../CustomComponents/CustomFormControl/CustomFormControl';
import { changeView, copyView, createNewView, getNewView, updateView } from '../../services/PraisoTableService';
import { useParams, useHistory } from 'react-router-dom';
import ErrorAlert from '../ErrorAlert/ErrorAlert';
import CustomCircularProgress from '../CustomComponents/CustomCircularProgress/CustomCircularProgress';
import { CustomCloseIcon } from '../CustomComponents/CustomIcon/CustomIcon';
import { DragNDrop, TableViewUpdateStatusEnum } from '../../config/app-globals.enum';
import CustomTooltip from '../CustomComponents/CustomTooltip/CustomTooltip';
import ViewActionDialog from '../Dialogs/ConfirmAction/ViewCreateAction';
import redCanvas from '../../assets/images/redCanvas.PNG';
import greenCanvas from '../../assets/images/greenCanvas.PNG';
import ErrorAlertTC from '../ErrorAlert/ErrorAlertTC';
import ReplaceActionDialog from '../Dialogs/ConfirmAction/ReplaceAction';
import { getDriverIdForTC, getSearchStringforTC, setDriverIdForTC, setIsCameFromEventDetailsPage, setSearchStringForTC } from "../../services/LocalStorageService";

const DragDrop = () => {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    const params = useParams();
    const driverId = getDriverIdForTC();
    const search = getSearchStringforTC();
    const [viewName, setViewName] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [foundComponent, setFoundComponent] = useState([]);
    const [component, setComponent] = useState([]);
    const [searchComponents, setSearchComponent] = useState([]);
    const [columnList, setColumnList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [oldColumnList, setOldColumnList] = useState([]);
    const [oldGroupList, setOldGroupList] = useState([]);
    const [pagination, setPagination] = useState(null);
    const [isDefaultTable, setDefaultTable] = useState(false);
    const [isAllField, setAllField] = useState(false);
    const [isApi, setIsApi] = useState(true);
    const [statusValue, setStatusValue] = useState();
    const [alertMessage, setAlertMessage] = useState("");
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [disableView, setDisableView] = useState(true);
    const groupByList = ["Rank", "FullName", "Score", "occurredAt", "userName", "groupName", "speed", "address",
        "speedZone", "severity", "isSchoolRunSpeeding", "isMotorwaySpeeding", "isDrivingBan", "eventTypeId",
        "duration", "name", "speedLimit", "isDriverBan", "schoolrunSpeeding", "motorway", "drivingBan",
        "registrationDate", "userRoles", "contentStatus", "isMobileLogin", "isWelcomeEmailSent"]; //@todo Get that list of groupby column
    const [alertMessageTC, setAlertMessageTC] = useState("");
    const [isAlertOpenTC, setIsAlertOpenTC] = useState(false);

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    useEffect(() => {
        if ((columnList.length > 0 || groupByList.length > 0) && viewName.length > 0) {
            setDisableView(false);
        } else {
            setDisableView(true);
        }
    }, [columnList, viewName])

    // ----
    const [tableStatusValue, setTableStatusValue] = React.useState(null);
    const [tableAlertType, setTableAlertType] = React.useState(null);
    const [tableAlertMessage, setTableAlertMessage] = React.useState("");
    const [tableAlertDescription, setTableAlertDescription] = React.useState("");
    const [isTableAlertOpen, setIsTableAlertOpen] = React.useState(false);
    const changeTableApiStatusCodeFunc = (status, isReplace) => {
        setTableStatusValue(status.code);
        if (status.code === 0 || status.code === 200 || status.code === 201) {
            setTableAlertMessage(status.message ? status.message : t("SUCCESS"));
            setTableAlertType("success");
            let userDescription = "";
            if (isReplace) {
                userDescription = t("TABLE_COMPONENT_HAS_BEEN_REPLACED_SUCCESSFULLY_REDIRECTING_TO_CREATED_TABLE_VIEW");
            } else {
                if (params.tcAction === DragNDrop.EDIT) {
                    userDescription = t("TABLE_COMPONENT_HAS_BEEN_UPDATED_SUCCESSFULLY_REDIRECTING_TO_UPDATED_TABLE_VIEW");
                } else if (params.tcAction === DragNDrop.COPY) {
                    userDescription = t("TABLE_COMPONENT_HAS_BEEN_COPIED_SUCCESSFULLY");
                } else {
                    userDescription = t("TABLE_COMPONENT_HAS_BEEN_CREATED_SUCCESSFULLY_REDIRECTING_TO_CREATED_TABLE_VIEW");
                }
            }
            setTableAlertDescription(userDescription);
        } else {
            setTableAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setTableAlertType("error");
            let userDescription = "";
            if (isReplace) {
                userDescription = t("FAILED_TO_REPLACE_TABLE_COMPONENT");
            } else {
                if (params.tcAction === DragNDrop.EDIT) {
                    userDescription = t("FAILED_TO_UPDATE_TABLE_COMPONENT");
                } else if (params.tcAction === DragNDrop.COPY) {
                    userDescription = t("FAILED_TO_COPY_TABLE_COMPONENT");
                } else {
                    userDescription = isReplace ? t("FAILED_TO_CREATE_TABLE_COMPONENT") : t("FAILED_TO_CREATE_TABLE_COMPONENT");
                }
            }
            setTableAlertDescription(userDescription);
        }
        setIsTableAlertOpen(true);
    };
    // ---
    React.useEffect(() => {
        // Get all columns for creating new view
        async function loadData() {
            setIsApi(true);
            const data = await getNewView(params);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                const tableConfig = data.content.tableConfig;
                let columnData = tableConfig.columns.map((col) => {
                    const newObje = {
                        columnCode: col.columnCode,
                        header: col.header,
                        order: col.order,
                        isRequired: col.isRequired,
                    }
                    return newObje;
                });
                setFoundComponent(columnData);
                setDefaultTable(data.content.isUserDefault !== undefined && data.content.isUserDefault === 1 ? true : false);
                setPagination(tableConfig.pageLengthArray);
                setValue(tableConfig.defaultPageSize);
                if (data.content.viewConfig) {
                    setDisableView(params.tcAction === DragNDrop.CREATE ? false : true);
                    const viewConfig = data.content.viewConfig;
                    setViewName(params.tcAction === DragNDrop.CREATE ? "" : data.content.viewName);
                    //filter the table column
                    viewConfig.groupByList.map((col) => {
                        viewConfig.columnList = viewConfig.columnList.filter((task) => {
                            if (task.columnCode !== col.columnCode) {
                                return task;
                            }
                        });
                    })
                    setColumnList(viewConfig.columnList);
                    setGroupList(viewConfig.groupByList);
                    setOldColumnList(viewConfig.columnList);
                    setOldGroupList(viewConfig.groupByList);
                    const pagination = viewConfig.pagination;
                    setPagination(pagination.pageLengthArray);
                    setValue(pagination.defaultPageSize);
                    setIsDisablePagination(pagination.isShowPagination === 0 ? true : false);
                    setOldPagination(pagination.isShowPagination === 0 ? true : false);
                    //Get the column list to drag
                    if (viewConfig.columnList.length === columnData.length) {
                        setComponent([]);
                    } else {
                        viewConfig.columnList.map((col) => {
                            columnData = columnData.filter((task) => {
                                if (task.columnCode !== col.columnCode) {
                                    return task;
                                }
                            });
                        });

                        viewConfig.groupByList.map((col) => {
                            columnData = columnData.filter((task) => {
                                if (task.columnCode !== col.columnCode) {
                                    return task;
                                }

                            });
                        })
                        setComponent(columnData);
                    }
                }
                setIsApi(false);
            } else {
                changeApiStatusCodeFunc(data.status);
            }
        }
        loadData();
    }, []);

    const handleSearch = (e) => {
        //Search column from list
        const keyword = e.target.value;
        if (keyword !== '') {
            const results = component.filter((component) => {
                return t(`COLUMN_NAME_${component.header}`).toLowerCase().includes(keyword.toLowerCase());
            });
            setSearchComponent(results);
        } else {
            // If the text field is empty, show all list
            setComponent(component);
        }
        setSearchValue(keyword);
    };

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [oldPagination, setOldPagination] = React.useState(false);
    const [isDisablePagination, setIsDisablePagination] = React.useState(false);
    const handleShowPagination = () => {
        //Enable -disable pagination
        isDisablePagination ? setIsDisablePagination(false) : setIsDisablePagination(true);
        setAnchorEl(null);
    }
    const [value, setValue] = React.useState(10);

    const handleChangePaginationValue = (e) => {
        //Set pagination size
        setValue(e.target.value);
        setAnchorEl(null);
    }

    const [id, setId] = useState('');
    const onDragStart = (ev, id, cat) => {
        setId(id);
        ev.dataTransfer.setData("id", id);
        ev.dataTransfer.setData("category", cat);
    }

    const onDragOver = (ev) => {
        ev.preventDefault();
    }

    const onDrop = (ev, cat) => {
        let id = ev.dataTransfer.getData("id");
        let category = ev.dataTransfer.getData("category");
        const gEle = document.getElementById(DragNDrop.GROUP);
        const tEle = document.getElementById(DragNDrop.TABLE);
        gEle.style.backgroundImage = ``;
        tEle.style.backgroundImage = ``;
        foundComponent.map((task) => {
            if (task.columnCode === id && cat !== category) {
                //Drop in table
                if (cat === DragNDrop.TABLE) {
                    setColumnList([...columnList, task]);
                    if (category === DragNDrop.LIST) {
                        const existingCol = component.filter((col) => {
                            return col.columnCode !== id
                        })
                        setComponent(existingCol);
                    } else if (category === DragNDrop.GROUP) {
                        let tasks = groupList.filter((task) => {
                            if (task.columnCode !== id) {
                                return task;
                            }
                        });

                        setGroupList(tasks);
                    }

                } else if (cat === DragNDrop.GROUP) {
                    //Drop in group and check that column isgroupby
                    if (groupByList.includes(id)) {
                        setGroupList([...groupList, task]);
                        if (category === DragNDrop.LIST) {
                            const existingCol = component.filter((col) => {
                                return col.columnCode !== id
                            })
                            setComponent(existingCol);
                        } else if (category === DragNDrop.TABLE) {
                            let tasks = columnList.filter((task) => {
                                if (task.columnCode !== id) {
                                    return task;
                                }

                            });
                            setColumnList(tasks);
                        }
                    } else {
                        setAlertMessageTC(t("THIS_COMPONENT_CAN_NOT_BE_ADDED_ON_THE_GROUP"));
                        setIsAlertOpenTC(true);
                    }
                } else if (cat === DragNDrop.LIST) {
                    setComponent([...component, task]);
                    //Remove from table and group
                    if (category === DragNDrop.TABLE) {
                        let tasks = columnList.filter((task) => {
                            if (task.columnCode !== id) {
                                return task;
                            }

                        });
                        setColumnList(tasks);
                    } else {
                        let tasks = groupList.filter((task) => {
                            if (task.columnCode !== id) {
                                return task;
                            }
                        });

                        setGroupList(tasks);
                    }
                }
            }
        });
    }

    useEffect(() => {
        //Check and Uncheck the all field checkbox
        if (component.length === 0) {
            setAllField(true);
        } else {
            setAllField(false);
        }
    }, [component]);

    const handleChange = (event) => {
        setAllField(event.target.checked);
        if (event.target.checked) {
            setColumnList([...columnList, ...groupList, ...component]);
            setComponent([]);
            setGroupList([]);
        } else {
            setComponent([...columnList, ...groupList]);
            setColumnList([]);
            setGroupList([]);
        }
    }
    
    const handleDefault = (e) => {
        setDefaultTable(e.target.checked);
    }

    const [existTcViewId, setExistTcViewId] = useState();
    const [isSystemDefault, setIsSystemDefault] = useState(null);
    async function loadData(request) {
        //Create,Update, copy and replace View
        let data: any;

        if (params.tcAction === DragNDrop.EDIT) {

            data = await updateView(request, params.tcViewId, params);
        } else if (params.tcAction === DragNDrop.COPY) {
            //changeTCView(request, isReplace);
            if (oldColumnList !== columnList || oldGroupList !== groupList || oldPagination !== isDisablePagination || isDefaultTable) {
                data = await createNewView(request);
            } else {
                data = await copyView(params.tcViewId, viewName.trim());
            }
        } else {
            // data = await createNewView(request, params);
            data = await createNewView(request);
        }
        setIsCameFromEventDetailsPage(1);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201)
        ) {
            if (data.content) {
                const content = data.content;
                if (content.isRecordExist && content.isRecordExist === 1) {
                    setExistTcViewId(content.existTcViewId && content.existTcViewId);
                    setIsSystemDefault(content.isSystemDefault && content.isSystemDefault === 1 ? true : false);
                    setDialogOpen(true);
                } else {
                    window.localStorage.setItem("viewId", data.content.id);
                    changeTableApiStatusCodeFunc(data.status, false);
                    if (params.tcAction === DragNDrop.COPY) {
                        showView(params.tcId);
                    } else {
                        showView(data.content.tcCode);
                    }
                }
            } else {
                window.localStorage.setItem("viewId", params.tcViewId);
                changeTableApiStatusCodeFunc(data.status, false);
                if (params.tcAction === DragNDrop.EDIT) {
                    showView(params.tcId);
                } else {
                    showView(data.content.tcCode);
                }
            }
        } else {
            changeTableApiStatusCodeFunc(data.status, false);
        }
    }

    function showView(tcCode: string) {
        if (tcCode === "WOL") {
            setTimeout(function () {
                history.push("/walloflegends");
            }, 1500);
        } else if (tcCode === "CE") {
            setTimeout(function () {
                history.push("/engagement");
            }, 1500);
        } else if (tcCode === "SEUL") {
            setTimeout(function () {
                history.push("/events#tabSPEEDING");
            }, 1500);
        } else if (tcCode === "BEUL") {
            setTimeout(function () {
                history.push("/events#tabBRAKING");
            }, 1500);
        } else if (tcCode === "CEUL") {
            setTimeout(function () {
                history.push("/events#tabCORNERING");
            }, 1500);
        } else if (tcCode === "MD") {
            setTimeout(function () {
                history.push("/events#tabDRIVER_DISTRACTION");
            }, 1500);
        } else if (tcCode === "SEL") {
            setDriverIdForTC(null);
            setTimeout(function () {
                history.push(`/userdetails/${driverId}`);
            }, 1500);
        } else if (tcCode === "BEL") {
            setDriverIdForTC(null);
            setTimeout(function () {
                history.push(`/userdetails/${driverId}`);
            }, 1500);
        } else if (tcCode === "CEL") {
            setDriverIdForTC(null);
            setTimeout(function () {
                history.push(`/userdetails/${driverId}`);
            }, 1500);
        } else if (tcCode === "DEL") {
            setDriverIdForTC(null);
            setTimeout(function () {
                history.push(`/userdetails/${driverId}`);
            }, 1500);
        } else if (tcCode === "RE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "BRE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "CRE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "ACCRE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "MDRE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "ARE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "BARE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "CARE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "ACCARE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "MDARE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "RRE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "BRRE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "CRRE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "ACCRRE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "MDRRE") {
            setTimeout(function () {
                history.push("/admin/reported-events");
            }, 1500);
        } else if (tcCode === "USR") {
            setTimeout(function () {
                setSearchStringForTC(null);
                history.push(`/admin/search${search}`);
            }, 1500);
        }
    }

    async function changeTCView(request, isReplace) {
        //Keep both and replace View
        const data = await changeView(request);

        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201)
        ) {
            if (data.content) {
                window.localStorage.setItem("viewId", data.content.id);
            } else {
                if (isReplace) {
                    window.localStorage.setItem("viewId", existTcViewId);
                } else {
                    window.localStorage.setItem("viewId", params.tcViewId);
                }
            }
            changeTableApiStatusCodeFunc(data.status, isReplace);
            showView(params.tcId);
        } else {
            changeTableApiStatusCodeFunc(data.status, isReplace);
        }
    }

    const [replaceDialogOpen, setReplaceDialogOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogAction] = useState("create");
    const createDialogFunc = (isOpen, confirmDelete, isReplace) => {
        setDialogOpen(isOpen);
        if (confirmDelete) {
            if (isReplace && isSystemDefault) {
                setReplaceDialogOpen(true);
            } else {
                const columnData = [...groupList, ...columnList];
                const request = {
                    //tcId: params.tcId, //@todo create const for all table component
                    //tcCode: params.tcId,
                    viewName: viewName.trim(),
                    isUserDefault: isDefaultTable ? 1 : 0,
                    recordStatus: 1, // 0 for delete view,
                    existTcViewId: existTcViewId,
                    currentTcViewId: 0,
                    changeStatus: isReplace ? TableViewUpdateStatusEnum.REPLACE : TableViewUpdateStatusEnum.KEEP_BOTH, //1->Keep Both;  2->Replace
                    viewConfig: {
                        columnList: columnData.map((col, i) => { return { ...col, order: i + 1 } }),
                        groupByList: groupList.map((col, i) => { return { ...col, order: i + 1 } }),
                        pagination: {
                            isShowPagination: isDisablePagination ? 0 : 1,
                            defaultPageSize: value,
                            pageLengthArray: pagination
                        }
                    }
                }
                if (params.tcViewId && params.tcAction !== DragNDrop.COPY) {
                    request.currentTcViewId = params.tcViewId;
                }
                changeTCView(request, isReplace);
            }
        }
    };

    const inputRef = React.useRef<HTMLDivElement>();
    const handleCreateView = () => {
        if (disableView) {
            inputRef.current.focus();
        } else {
            const columnData = [...groupList, ...columnList];
            const request = {
                //tcId: params.tcId, //@todo create const for all table component
                tcCode: params.tcId,
                viewName: viewName.trim(),
                isUserDefault: isDefaultTable ? 1 : 0,
                recordStatus: 1, // 0 for delete view
                viewConfig: {
                    columnList: columnData.map((col, i) => { return { ...col, order: i + 1 } }),
                    groupByList: groupList.map((col, i) => { return { ...col, order: i + 1 } }),
                    pagination: {
                        isShowPagination: isDisablePagination ? 0 : 1,
                        defaultPageSize: value,
                        pageLengthArray: pagination
                    }
                }
            }
            if (params.tcAction === DragNDrop.EDIT) {
                delete request.tcCode;
            }

            loadData(request);
        }
    }

    const handleRemoveField = (id, cat) => {
        //Remove field when click on cancle 
        if (cat === DragNDrop.TABLE) {
            let tasks = columnList.filter((task) => {
                if (task.columnCode !== id) {
                    return task;
                }

            });
            setColumnList(tasks);
        } else {
            let tasks = groupList.filter((task) => {
                if (task.columnCode !== id) {
                    return task;
                }
            });

            setGroupList(tasks);
        }
        foundComponent.map((task) => {
            if (task.columnCode === id) {
                setComponent([...component, task]);
            }
        })
    }

    const handleDrop = (e, cat, code) => {
        let id = e.dataTransfer.getData("id");
        if (cat === "group") {
            let oldIndex = groupList.findIndex((task) => {
                return task.columnCode === id
            });
            let newIndex = groupList.findIndex((task) => {
                return task.columnCode === code
            });
            if (newIndex >= groupList.length) {
                var k = newIndex - groupList.length + 1;
                while (k--) {
                    groupList.push(undefined);
                }
            }
            groupList.splice(newIndex, 0, groupList.splice(oldIndex, 1)[0]);
            setGroupList([...groupList]);
        } else {
            let oldIndex = columnList.findIndex((task) => {
                return task.columnCode === id
            });
            let newIndex = columnList.findIndex((task) => {
                return task.columnCode === code
            });
            if (newIndex >= columnList.length) {
                var k = newIndex - columnList.length + 1;
                while (k--) {
                    columnList.push(undefined);
                }
            }
            columnList.splice(newIndex, 0, columnList.splice(oldIndex, 1)[0]);
            setColumnList([...columnList]);
        }
    }

    //set Element to prevent the child call
    const [ele, setEle] = useState(null);
    const onDragEnter = (e, cat) => {
        setEle(e.target);
        e.stopPropagation();
        e.preventDefault();
        const ele = document.getElementById(cat);
        if (cat === DragNDrop.GROUP) {
            const tEle = document.getElementById(DragNDrop.TABLE);
            tEle.style.backgroundImage = ``;
            if (groupByList.includes(id)) {
                ele.style.backgroundImage = `url(${greenCanvas})`;
            } else {
                ele.style.backgroundImage = `url(${redCanvas})`;
            }
        } else {
            const gEle = document.getElementById(DragNDrop.GROUP);
            gEle.style.backgroundImage = ``;
            ele.style.backgroundImage = `url(${greenCanvas})`;
        }

    }

    const onDragLeave = (e, cat) => {
        if (ele === e.target) {
            const ele = document.getElementById(cat);
            ele.style.backgroundImage = ``;
            setEle(null);
        }
    }

    const handleReplaceView = (isOpen) => {
        setReplaceDialogOpen(isOpen);
        inputRef.current.focus();
    }

    return (
        <>
            <div className={classes.dragdropComponent}>
                <div className={classes.columns}>
                    <div>
                        <CustomTextField
                            disabled={component.length === 0 ? true : false}
                            value={searchValue}
                            placeholder={t("SEARCH_COMPONENT")}
                            onChange={handleSearch}
                            // onChange={filter}
                            className={classes.componentSearch}
                            InputProps={{
                                endAdornment: (
                                    <CustomInputAdornment position='start'>
                                        <CustomIconButton>
                                            {searchValue.length > 0 ? <CustomCloseIcon onClick={() => setSearchValue("")} /> : <SearchIcon />}
                                        </CustomIconButton>
                                    </CustomInputAdornment>
                                ),
                                disableUnderline: true
                            }}
                        />
                        {/* <div id='draggedComponents' className="componentList"> */}
                        {component.length > 0 ? <CustomTypography className={classes.dragtext}>
                            {t("DRAG_AN_ITEM_FROM_HERE_TO_CANVAS")}
                        </CustomTypography> : null
                        }
                        <div id='componentList' className={classes.componentsList} onDragOver={(e) => onDragOver(e)}
                            onDrop={(e) => onDrop(e, DragNDrop.LIST)}>

                            {!isApi ? (
                                searchValue && searchValue.length > 0 ? searchComponents.map((component, index) => {
                                    return (<span draggable="true" key={component.columnCode} className={classes.componentsField} onDragStart={(e) => onDragStart(e, component.columnCode, DragNDrop.LIST)}>{t(`COLUMN_NAME_${component.header}`)}</span>)
                                }) : component.length > 0 ? component.map((component, index) => {
                                    return (<span draggable="true" key={component.columnCode} className={classes.componentsField} onDragStart={(e) => onDragStart(e, component.columnCode, DragNDrop.LIST)}>{t(`COLUMN_NAME_${component.header}`)}</span>)
                                }) : <CustomTypography className={classes.colName}>
                                    {t("ALL_THE_FIELDS_ALREADY_IN_USE_ON_THE_VIEW")}
                                </CustomTypography>) : <CustomCircularProgress />}
                        </div>
                    </div>
                    <CustomFormControlLabel
                        control={
                            <CustomCheckbox
                                color="primary"
                                checked={isAllField}
                                onChange={(e) => handleChange(e)}
                            // name="checkedF"
                            />
                        }
                        label={!isAllField ? t('ADD_ALL_THE_FIELDS_ON_THE_VIEW') : t('REMOVE_ALL_THE_FIELDS_ON_THE_VIEW')}
                    />
                </div>

                <div className={classes.groupandtable}>

                    <div id='group' className={groupList && groupList.length > 0 ? classes.dragHereUpdated : classes.dragHere} onDragEnter={(e) => onDragEnter(e, DragNDrop.GROUP)} onDragLeave={(e) => onDragLeave(e, DragNDrop.GROUP)} onDragOver={(e) => onDragOver(e)}
                        onDrop={(e) => onDrop(e, DragNDrop.GROUP)}>
                        <CustomTypography className={classes.dragdropLabelTitle}>
                            {t("CREATE_A_GROUP")}
                        </CustomTypography>
                        <CustomTypography className={classes.dragdropsubTitleLabel}>
                            {t('DRAG_AND_DROP_THE_COMPONENT_TO_CREATE_GROUP')}
                        </CustomTypography>
                        <div className={classes.draggedComponents} >
                            {
                                groupList && groupList.map((component, index) => {
                                    return (
                                        <div className={classes.columnContainer} key={component.columnCode} onDragStart={(e) => onDragStart(e, component.columnCode, DragNDrop.GROUP)} onDrop={(e) => handleDrop(e, DragNDrop.GROUP, component.columnCode)}>
                                            <CustomTooltip title={t("CANCEL_COMPONENT")} placement="top">
                                                <div className={classes.cancelColumn} style={{ display: "none" }} >
                                                    <CustomCloseIcon fontSize="small" className={classes.closeFieldIcon} onClick={() => handleRemoveField(component.columnCode, DragNDrop.GROUP)} />
                                                </div>
                                            </CustomTooltip>
                                            <span draggable="true" className={classes.components} >{t(`COLUMN_NAME_${component.header}`)}</span>
                                            <div className={classes.blank}></div>
                                            <div className={classes.blank}></div>
                                        </div>
                                    )
                                })
                            }
                        </div>

                    </div>

                    <div id="table" className={columnList && columnList.length > 0 ? classes.dragHereUpdated : classes.dragHere} onDragEnter={(e) => onDragEnter(e, DragNDrop.TABLE)} onDragLeave={(e) => onDragLeave(e, DragNDrop.TABLE)} onDragOver={(e) => onDragOver(e)}
                        onDrop={(e) => { onDrop(e, DragNDrop.TABLE) }}>

                        <CustomTypography className={classes.dragdropLabelTitle}>
                            {t("CREATE_A_TABLE")}
                        </CustomTypography>
                        <CustomTypography className={classes.dragdropsubTitleLabel}>
                            {t('DRAG_AND_DROP_THE_COMPONENT_FROM_COMPONENT_PANEL_TO_CREATE_TABLE')}
                        </CustomTypography>

                        <div className={classes.draggedComponents} >
                            {
                                columnList && columnList.map((component, index) => {
                                    return (
                                        <div className={classes.columnContainer} key={component.columnCode} onDragStart={(e) => onDragStart(e, component.columnCode, DragNDrop.TABLE)} onDrop={(e) => handleDrop(e, DragNDrop.TABLE, component.columnCode)}>
                                            <CustomTooltip title={t("CANCEL_COMPONENT")} placement="top">
                                                <div className={classes.cancelColumn} style={{ display: "none" }}>
                                                    <CustomCloseIcon fontSize="small" className={classes.closeFieldIcon} onClick={() => handleRemoveField(component.columnCode, DragNDrop.TABLE)} />
                                                </div>
                                            </CustomTooltip>
                                            <span draggable="true" className={classes.components}>{t(`COLUMN_NAME_${component.header}`)}</span>
                                            <div className={classes.blank}></div>
                                            <div className={classes.blank}></div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}

            <CustomGrid container
                spacing={0}
                //justifyContent="space-evenly"
                alignItems="center"
                justifyContent="center"
                className={classes.footer}
            >

                <CustomGrid className={classes.settingData} item style={{ display: "flex", flexDirection: 'row', alignItems: 'center' }}>
                    <IconButton className={classes.margin} onClick={handleClick}>
                        <HorizontalSplitIcon fontSize="large" />
                    </IconButton>
                    <CustomMenu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}

                    >
                        <CustomMenuItem >
                            <CustomFormControlLabel
                                control={
                                    <CustomCheckbox
                                        color="primary"
                                        checked={isDisablePagination}
                                        onChange={handleShowPagination}
                                    />
                                }
                                label={t('DONT_SHOW_PAGINATION')}
                            />
                        </CustomMenuItem>
                        <CustomMenuItem className={classes.paginationCount}>
                            <CustomFormControl fullWidth  >
                                <CustomSelect
                                    disableUnderline
                                    labelId="pagination-select-label"
                                    id="pagination-select"
                                    value={value}
                                    disabled={isDisablePagination}
                                    label="pagination"
                                    onChange={handleChangePaginationValue}
                                >
                                    {pagination && pagination.map((page, index) => {
                                        return <CustomMenuItem key={index} value={page} >{page}</CustomMenuItem>
                                    })}
                                    {/* <CustomMenuItem value={10}>10</CustomMenuItem>
                                    <CustomMenuItem value={20}>20</CustomMenuItem>
                                    <CustomMenuItem value={50}>50</CustomMenuItem>
                                    <CustomMenuItem value={100}>100</CustomMenuItem>
                                    <CustomMenuItem value={500}>500</CustomMenuItem> */}
                                </CustomSelect>
                            </CustomFormControl>
                            <CustomTypography >
                                {t('ITEMS_PER_PAGE')}
                            </CustomTypography>
                        </CustomMenuItem>
                    </CustomMenu>
                    <CustomTypography >
                        {t('ROW_SETTEINGS')}
                    </CustomTypography>
                    <div style={{ borderLeft: '0.5px solid #f1f2f6', marginLeft: '60px', marginRight: '60px', height: "50px" }}></div>
                    <CustomFormControlLabel
                        control={
                            <CustomCheckbox
                                color="primary"
                                checked={isDefaultTable}
                                onChange={(e) => handleDefault(e)}
                            />
                        }
                        label={t('SET_AS_DEFAULT')}
                    />
                </CustomGrid>
                <CustomGrid item style={{ display: "flex", flexDirection: 'row', alignItems: 'center' }}>
                    <CustomTextField
                        inputRef={inputRef}
                        autoFocus
                        placeholder={t("ENTER_THE_NAME_OF_THE_VIEW")}
                        className={viewName.length > 0 ? classes.viewNameTextField : classes.viewNameTextFieldAdd}
                        InputProps={{
                            disableUnderline: true
                        }}
                        value={viewName}
                        onChange={(e) => setViewName(e.target.value)}
                    />
                    {/* columnList.find(({ isRequired}) => !isRequired) */}
                    <CustomButton disabled={viewName.trim().length === 0 || columnList.length === 0 && groupList.length === 0 || !columnList.includes(columnList.find(({ isRequired }) => isRequired)) && !groupList.includes(groupList.find(({ isRequired }) => isRequired))} className={classes.createButton} onClick={() => handleCreateView()}>
                        {params.tcAction === DragNDrop.EDIT ? t('UPDATE') : t('CREATE')}
                    </CustomButton>
                </CustomGrid>
            </CustomGrid>
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
            <ErrorAlert
                code={tableStatusValue}
                message={tableAlertMessage}
                description={tableAlertDescription}
                isOpen={isTableAlertOpen}
                alertType={tableAlertType}
                isClose={(isClose) => setIsTableAlertOpen(!isClose)}
            />
            <ViewActionDialog
                dialogOpen={dialogOpen}
                dialogClose={(isOpen, confirmDelete, replaceViewName) =>
                    createDialogFunc(isOpen, confirmDelete, replaceViewName)
                }
                dialogAction={dialogAction}
                viewName={viewName}
            />
            <ErrorAlertTC
                message={alertMessageTC}
                isOpen={isAlertOpenTC}
                isClose={(isClose) => setIsAlertOpenTC(!isClose)}
            />
            <ReplaceActionDialog
                dialogOpen={replaceDialogOpen}
                dialogClose={(isOpen) => handleReplaceView(isOpen)}
                dialogMessage={i18n.t("IS_DEFAULT_PRAISO_VIEW_YOU_CAN_NOT_HAVE_THE_SAME_NAME_FOR_THIS_VIEW_PLEASE_ADD_DIFFERENT_NAME_AND_TRY_AGAIN", { viewName: viewName })}
            />
        </>
    )
}

export default DragDrop